/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TellerDto { 
    id?: number;
    name?: string | null;
    userName?: string | null;
    branchName?: string | null;
    userId?: number;
    branchId?: number;
    accountingCode?: string | null;
    accountId?: string | null;
    maxWithdrawalLimitWithoutApproval?: number;
    maxWithdrawalLimitWithoutApprovalShow?: boolean;
    maxDepositLimitWithoutApproval?: number;
    maxDepositLimitWithoutApprovalShow?: boolean;
    maxRepaymentLimitWithoutApproval?: number;
    maxRepaymentLimitWithoutApprovalShow?: boolean;
    maxDisbursementLimitWithoutApproval?: number;
    maxDisbursementLimitWithoutApprovalShow?: boolean;
    postPrincipalInterestAndPenaltySeprately?: boolean;
    allowsTransferToOtherTellers?: boolean;
    allowPostingOnBehalfOfOtherTellers?: boolean;
}

